import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { RootStore } from './../data/store'
import { AESEncrypt, generateRandomString, isEmpty, isOsMobile, RSAEncrypt } from './../util/util'
import { APIEndPoints } from './APIEndpoints'
import { appSessionRefreshConfig, BASE_URL } from './config'

const responseParser = (response: any) => ({
  identifierToken: response?.session?.appIdentifierToken,
  refreshToken: response?.session?.refreshToken?.tokenValue,
  accessToken: response?.session?.accessToken?.tokenValue,
  accessTokenExpiresIn: response?.session?.accessToken?.expiresIn,
  refreshTokenExpiresIn: response?.session?.refreshToken?.expiresIn,
})

export const extendAppSession = (accessToken: string, refreshToken: string) => {
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, accessToken)
  let refToken = AESEncrypt(randomEncryptionKey, refreshToken)

  const request: Request<{}> = {
    apiPath: `${BASE_URL}${APIEndPoints.appSessionExtend}`,
    method: 'POST',
    headers: appSessionRefreshConfig().headers,
    body: {
      application: {
        clientId: isOsMobile() ? Config.REACT_APP_CLIENT_ID : window?._env_?.REACT_APP_CLIENT_ID,
      },
      authenticateList: [
        {
          mode: 14,
          accessToken: token,
          refreshToken: refToken,
        },
      ],
      scope: 'SESSION',
      purpose: 1,
      secure: {
        encryptionKey: encryptedKey ?? '',
      },
    },
  }
  return request
}

export const AppHeaderTransformer = async (response: Response, originalRequest?: Request<any>) => {
  if (response) {
    const { data } = response
    if (
      data?.status === 'SUCCESS' &&
      !isEmpty(data?.session?.accessToken?.tokenValue) &&
      !isEmpty(data?.session?.refreshToken?.tokenValue) &&
      !isEmpty(data?.session?.appIdentifierToken)
    ) {
      const appSessionData = responseParser(data)
      await RootStore.user.session.updateAppSessionData(
        appSessionData.accessToken,
        appSessionData.refreshToken,
        appSessionData.accessTokenExpiresIn,
        appSessionData.refreshTokenExpiresIn,
        appSessionData.identifierToken,
      )

      if (
        appSessionData &&
        originalRequest &&
        appSessionData.accessToken &&
        appSessionData.identifierToken &&
        originalRequest.headers
      ) {
        originalRequest.headers = {
          ...originalRequest.headers,
          'x-app-access-token': appSessionData.accessToken,
          'x-trace-id': generateRandomString(16),
          'x-appid-token': appSessionData.identifierToken,
        }
      }
    } else {
      await RootStore.user.session.updateAppSessionData('', '', -1, -1, '')
      await RootStore.user.session.updateUserSessionData('', '', '', -1, -1, '')
      RootStore.settings.metaData.updateSelectedMercName('')
      RootStore.user.updateSelectedMercMid('')
    }
  }
}

export const AppHeaderTransformerAgent = (response: Response, originalRequest?: Request<any>) => {
  const { data } = response
  if (
    data?.status === 'SUCCESS' &&
    !isEmpty(data?.session?.accessToken?.tokenValue) &&
    !isEmpty(data?.session?.refreshToken?.tokenValue) &&
    !isEmpty(data?.session?.appIdentifierToken)
  ) {
    const appSessionData = responseParser(data)
    RootStore.agentQrSession.updateAppTokens(data)

    if (
      appSessionData &&
      originalRequest &&
      appSessionData.accessToken &&
      appSessionData.identifierToken &&
      originalRequest.headers
    ) {
      originalRequest.headers = {
        ...originalRequest.headers,
        'x-app-access-token': appSessionData.accessToken,
        'x-trace-id': generateRandomString(16),
        'x-appid-token': appSessionData.identifierToken,
      }
    }
  } else {
    RootStore.agentQrSession.resetAccessToken()
    window?.localStorage.removeItem('csoSessData')
    window.localStorage.removeItem('csoUserMobileNumber')
  }
}

export const extendAppSessionAPI = () => {
  const appAccessToken = RootStore?.user?.session?.appAccessToken
  const appRefToken = RootStore?.user?.session?.appRefreshToken
  const request = extendAppSession(appAccessToken, appRefToken)
  return executeRequest(request).then((response) => {
    return AppHeaderTransformer(response)
  })
}
